import Org from './org/org'

const SUB_SYSTEM = 'authcenter'
// 组织机构
export const orgApi = new Org(SUB_SYSTEM, 'org')
